import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.home")) +
                          " "
                      ),
                    ]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: {
                        exact: true,
                        to: { name: "processWorksheet", params: {} },
                        active: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.worksheet.worksheet")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between flex-column flex-md-row mb-4",
                    },
                    [
                      _c(VTextField, {
                        attrs: {
                          outlined: "",
                          clearable: "",
                          label:
                            _vm.$vuetify.lang.t(
                              "$vuetify.worksheet.worksheet"
                            ) +
                            " " +
                            _vm.$vuetify.lang.t("$vuetify.label.id"),
                          "append-icon": "mdi-magnify",
                          "hide-details": "",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.search.apply(null, arguments)
                          },
                          "click:append": _vm.search,
                          "click:clear": _vm.clearSearch,
                        },
                        model: {
                          value: _vm.parameters.wsId,
                          callback: function ($$v) {
                            _vm.$set(_vm.parameters, "wsId", $$v)
                          },
                          expression: "parameters.wsId",
                        },
                      }),
                      _c(VDivider, {
                        staticClass: "mx-2 mt-0 mt-sm-4 my-auto",
                        attrs: { vertical: "" },
                      }),
                      _c("page-params", {
                        attrs: {
                          pageName: "processWorksheet",
                          vuexName: "worksheetSearchParameters",
                          parameters: _vm.parameters,
                          outlined: "",
                          "hide-details": "",
                        },
                        on: {
                          onLoad: function ($event) {
                            return _vm.search()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VExpansionPanels,
                    {
                      model: {
                        value: _vm.showSearch,
                        callback: function ($$v) {
                          _vm.showSearch = $$v
                        },
                        expression: "showSearch",
                      },
                    },
                    [
                      _c(
                        VExpansionPanel,
                        [
                          _c(
                            VExpansionPanelHeader,
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex flex-column flex-md-row",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.base.search"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(VExpansionPanelContent, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-space-between flex-md-row flex-column",
                              },
                              [
                                _c(VTextField, {
                                  staticClass: "mr-md-2 mb-6 mb-md-0",
                                  attrs: {
                                    label: _vm.$vuetify.lang.t(
                                      "$vuetify.base.startDate"
                                    ),
                                    type: "date",
                                    clearable: "",
                                    dense: "",
                                    "hide-details": "",
                                    rules: [_vm.rules.required],
                                  },
                                  model: {
                                    value: _vm.parameters.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.parameters, "startDate", $$v)
                                    },
                                    expression: "parameters.startDate",
                                  },
                                }),
                                _c(VTextField, {
                                  staticClass: "ml-0 ml-lg-4",
                                  attrs: {
                                    label: _vm.$vuetify.lang.t(
                                      "$vuetify.base.endDate"
                                    ),
                                    type: "date",
                                    clearable: "",
                                    dense: "",
                                    "hide-details": "",
                                    rules: [
                                      _vm.rules.dateRange(
                                        _vm.parameters.startDate,
                                        _vm.parameters.endDate
                                      ),
                                    ],
                                  },
                                  model: {
                                    value: _vm.parameters.endDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.parameters, "endDate", $$v)
                                    },
                                    expression: "parameters.endDate",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(VSelect, {
                                  staticClass: "mt-5",
                                  attrs: {
                                    items: _vm.users,
                                    "item-text": "firstName",
                                    "item-value": "id",
                                    label: "Filter by user",
                                    placeholder: "All Users",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.parameters.staffId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.parameters, "staffId", $$v)
                                    },
                                    expression: "parameters.staffId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(VSelect, {
                                  staticClass: "mt-2",
                                  attrs: {
                                    items: _vm.worksheetTypeDefinitions,
                                    "item-text": "worksheetType",
                                    "item-value": "id",
                                    label: "Filter by Worksheet Type",
                                    placeholder: "All Worksheet Types",
                                    clearable: "",
                                  },
                                  on: { change: _vm.worksheetTypeChange },
                                  model: {
                                    value: _vm.parameters.filterTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.parameters,
                                        "filterTypeId",
                                        $$v
                                      )
                                    },
                                    expression: "parameters.filterTypeId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.worksheetType &&
                            _vm.worksheetType.hasProcessType
                              ? _c(
                                  "div",
                                  [
                                    _vm.processTypes
                                      ? _c(VSelect, {
                                          attrs: {
                                            clearable: "",
                                            dense: "",
                                            outlined: "",
                                            label:
                                              "Manufactoring Process Types",
                                            items: _vm.processTypes,
                                            "item-text": "name",
                                            "item-value": "id",
                                          },
                                          model: {
                                            value: _vm.parameters.processTypeId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                "processTypeId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "parameters.processTypeId",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.worksheetType && _vm.worksheetType.hasCustomer
                              ? _c(
                                  "div",
                                  [
                                    _vm.customers
                                      ? _c(VSelect, {
                                          attrs: {
                                            clearable: "",
                                            dense: "",
                                            outlined: "",
                                            label: "Customer",
                                            items: _vm.customers,
                                            "item-text": "name",
                                            "item-value": "id",
                                          },
                                          model: {
                                            value: _vm.parameters.customerId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                "customerId",
                                                $$v
                                              )
                                            },
                                            expression: "parameters.customerId",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column flex-lg-row" },
                              [
                                _c(VTextField, {
                                  staticClass: "flex-grow-1",
                                  attrs: {
                                    dense: "",
                                    placeholder:
                                      "Press enter to begin searching memo, notes, document#, product name or plate number",
                                    "append-icon": "mdi-magnify",
                                    outlined: "",
                                    clearable: "",
                                    label: "Search",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.search.apply(null, arguments)
                                    },
                                    "click:clear": _vm.clearSearch,
                                  },
                                  model: {
                                    value: _vm.parameters.searchTerms,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.parameters,
                                        "searchTerms",
                                        $$v
                                      )
                                    },
                                    expression: "parameters.searchTerms",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-row ml-0 ml-lg-4 mb-2 mb-lg-0 flex-shrink-0 flex-md-row flex-column",
                                  },
                                  [
                                    _vm.statuses
                                      ? _c(VSelect, {
                                          staticClass:
                                            "flex-grow-0 ml-0 ml-lg-5",
                                          attrs: {
                                            clearable: "",
                                            dense: "",
                                            outlined: "",
                                            label: "Filter Status",
                                            items: _vm.statuses,
                                            "item-text": "name",
                                            "item-value": "value",
                                          },
                                          model: {
                                            value: _vm.parameters.status,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "parameters.status",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-center" },
                              [
                                _c(
                                  VBtn,
                                  {
                                    attrs: { color: "primary" },
                                    on: { click: _vm.search },
                                  },
                                  [_vm._v(" Submit ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider, { staticClass: "my-5" }),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _vm.processWorksheetList &&
                      _vm.processWorksheetList.length > 0
                        ? _c(
                            VBtn,
                            {
                              staticClass: "my-2 my-md-5 mr-4",
                              attrs: { small: "", loading: _vm.isAppLoading },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadExcel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.base.download"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.processWorksheetList &&
                  _vm.processWorksheetList.length > 0 &&
                  _vm.pagination.totalSize > 0
                    ? _c(
                        "div",
                        { staticClass: "text-caption font-weight-light ml-4" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.label.foundX",
                                  _vm.pagination.totalSize
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "infinite-scroll",
                    {
                      key: _vm.infiniteScrollKey,
                      attrs: { totalPages: _vm.pagination.totalPages },
                      on: {
                        fetchData: _vm.getResources,
                        "update:totalPages": function ($event) {
                          return _vm.$set(_vm.pagination, "totalPages", $event)
                        },
                        "update:total-pages": function ($event) {
                          return _vm.$set(_vm.pagination, "totalPages", $event)
                        },
                      },
                    },
                    _vm._l(
                      _vm.processWorksheetList,
                      function (worksheet, index) {
                        return _c("worksheet-card", {
                          key: worksheet ? worksheet.id : "null",
                          attrs: {
                            worksheet: worksheet,
                            showEditButtons: true,
                            index: index + 1,
                          },
                          on: {
                            print: _vm.print,
                            edit: _vm.edit,
                            remove: _vm.remove,
                          },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }